export default __webpack_public_path__ + "static/media/Bank_of_Scotland.c713c6fc.svg";